var lib_core            = require("lib-core");

var TabController = require("./../tab/tabController.js");

var ToolbarModel        = require("./toolbarModel.js");
var ToolbarView         = require("./toolbarView.js");
var ToolbarStateMachine = require("./toolbarStateMachine.js");

var ToolbarController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    this.offsetButtons = (configuration ? configuration.offsetButtons : false);

    lib_core.GuiEvents.addEvents({
        SET_TOOL: {id: 'abs_27', name: "SET_TOOL", isGuiButton: true },
        TOOLBAR_SWITCH_MODE: {id: 'tbr_01', name: "TOOLBAR_SWITCH_MODE", isGuiButton: true }
    });
};
lib_core.inherit(ToolbarController, lib_core.Controller);
ToolbarController.inject  = {
    tabController : TabController,
};

module.exports = ToolbarController;

ToolbarController.prototype.createView = function () {
    var tabView = this.tabController.getView();
    return new ToolbarView(this.getModel(), tabView, this.rootStateMachine);
};

ToolbarController.prototype.createModel = function () {
    if (this.configuration && this.configuration.viewOnly && this.configuration.viewOnly === true) {
        return null;
    } else {
        return new ToolbarModel();
    }
};

ToolbarController.prototype.createStateMachine = function () {
    if (this.configuration && this.configuration.viewOnly && this.configuration.viewOnly === true) {
        return null;
    } else {
        return new ToolbarStateMachine(this.root, this.getModel());
    }
};

ToolbarController.prototype.registerToolView = function(tool, mode) {
    this.getView().registerTool(tool, mode, this.offsetButtons);
};

ToolbarController.prototype.registerTool = function(tool, mode, autoEscape, enterFunction, exitFunction) {
    this.registerToolView(tool, mode);
    var toolName = tool.name();
    if(mode) toolName += "_"+mode.name();
    this.getStatemachine().registerTool(toolName, autoEscape, enterFunction, exitFunction);
};

ToolbarController.prototype.registerMode = function(mode) {
    this.getModel().modes.push(mode);
    if(!this.getModel().activeMode()) this.getModel().activeMode(mode);
};

ToolbarController.prototype.afterBuild = function () {
    if(this.getModel().modes.size()) this.getView().addModeSwitcher();
};
